import React from 'react';
import PropTypes from 'prop-types';
import WMIconMenu from '@workmarket/front-end-components/dist/WMIconMenu';
import WMIconButton from '@workmarket/front-end-components/dist/WMIconButton';
import HeadsetIcon from 'material-ui/svg-icons/hardware/headset-mic';
import DefaultChatMenu from './DefaultChatMenu';
import SupportMenuItems from './SupportMenuItems';

const SocialChatMenu = ({ useZoomChat, ...props }) => {
	return (
		<WMIconMenu
			anchorOrigin={ { horizontal: 'right', vertical: 'top' } }
			className="app-social-menu"
			iconButtonElement={
				<WMIconButton
					className="app-social-menu-btn"
					style={ { verticalAlign: 'middle' } }
				>
					<HeadsetIcon color="#ffffff" />
				</WMIconButton>
			}
			targetOrigin={ { horizontal: 'right', vertical: 'top' } }
		>
			{ useZoomChat
				? <SupportMenuItems { ...props } />
				: <DefaultChatMenu { ...props } />
			}
		</WMIconMenu>
	);
};

SocialChatMenu.propTypes = {
	useZoomChat: PropTypes.bool
};

SocialChatMenu.defaultProps = {
	useZoomChat: false
};

export default SocialChatMenu;
